import { Component, HostBinding } from '@angular/core';

@Component({
	selector: 'ui-grid-container',
	template: `<ng-content></ng-content>`
})
export class UIGridContainerComponent {
	@HostBinding('class') cls = 'd-flex flex-column h-100';
}
